/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { IRpatrimonio } from '../../../shared/services/api/cadastros/PatrimoniosService';
pdfMake.vfs = pdfFonts.pdfMake.vfs;


async function RPatrimonio(dados: IRpatrimonio[], tipo: string) {

  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img: HTMLImageElement = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = function () {
        const canvas: HTMLCanvasElement = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Não foi possível obter o contexto 2D');
          return;
        }
        const image = this as HTMLImageElement;
        canvas.height = image.naturalHeight;
        canvas.width = image.naturalWidth;
        ctx.drawImage(image, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = function () {
        reject(`Não foi possível carregar a imagem de ${url}`);
      };
      img.src = url;
    });
  }

  const imageUrl = process.env.REACT_APP_URL_IMGLOG || '';
  const imageData = await getBase64ImageFromUrl(imageUrl);

  const TotalGeral = dados.reduce((acc, item) => acc + item.valoraquisicao, 0);

  const documentDefinition: any = {
    pageSize: 'A4',
    pageMargins: [20, 22, 10, 40],
    header: {
      columns: [
        { text: 'Sif - Sistema Integrado de Fazendas', alignment: 'right', color: 'gray',  fontSize: 6,  margin: [0, 10, 30, 0], }
      ]
    },   
    footer: function (currentPage: number, pageCount: number) {
      return {
        text: `Página ${currentPage} de ${pageCount}`,
        alignment: 'right',
        fontSize: 6,
        color: 'gray',
        margin: [0, 0, 30, 0],
      };
    },
    content: [
      {
        style: 'tableExample',
        table: {
          margin: [0, 0, 0, 0],
          widths: [48, 800],
          body: [
            [
              {
                image: imageData,
                width: 48,
                border: [false, false, false, false]
              },
              {
                width: 800,
                border: [false, false, false, false],
                table: {
                  body: [
                    [
                      { text: process.env.REACT_APP_URL_EMPRESA, fontSize: 16, margin: [0, 5, 0, 0], bold: true, color: process.env.COR_RELATORIOS_TEXTO, alignment: 'center', fillColor: process.env.COR_RELATORIOS, border: [false, false, false, false] },
                    ],
                    [
                      { text: process.env.REACT_APP_URL_ENDERECO, fontSize: 10, border: [false, false, false, true] },
                    ],
                    [
                      { text: 'Relatório de Patrimônio', margin: [5, 10, 0, 0], fontSize: 18, bold: true, alignment: 'center', border: [false, false, false, false] },
                    ],
                  ]
                }
              }
            ],
          ]
        }
      },
      { text: tipo, fontSize: 10, alignment: 'left' },

      await Promise.all(
        dados.flatMap(async (e) => {
          const imageData1 = await getBase64ImageFromUrl(e.fotos === null ? '/logo.jpeg' : process.env.REACT_APP_URL_IMGPATRIMONIO + e.fotos.imgPath || '');

          return [
            [
              [
                {
                  table: {
                    widths: [50, 410, 60],
                    border: [false, false, false, false],
                    body: [
                      [
                        {
                          image: imageData1, width: 48,
                          height: 48,
                          alignment: 'center'
                        },
                        {
                          text: 'Patrimônio: ' + e.descricao + '\n Numero: ' + e.numero + '   Ano: ' + e.ano + '    Modelo: ' + e.modelo +
                            '\nCor: ' + e.cor + '  Localizado:  ' + e.fazenda + '   Grupo: ' + e.grupo,
                          fontSize: 12, bold: true, alignment: 'left'
                        },
                        {
                          text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(e.valoraquisicao),
                          margin: [0, 15, 0, 0], alignment: 'right', fontSize: 10
                        },
                      ],
                    ],
                  },
                } 
              ],
            ]
          ];
        })
      ),
      {
        text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(TotalGeral),
        margin: [0, 5, 25, 0], fontSize: 15, alignment: 'right'
      },
    ]
  };
  pdfMake.createPdf(documentDefinition).open();
}
export default RPatrimonio;


